import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  consultClientPEP: {},
  clientePepPositivaPregunta1: {},
  clientePepPositivaPregunta2: {},
  clientePepRespuestasNegativas: {},
};

export const pepSlice = createSlice({
  name: 'pep',
  initialState,
  reducers: {

    // Consult PEP Client

    setConsultClientPEPLoading: (state) => {
      state.consultClientPEP = {
        isLoading: true,
      };
    },

    setConsultClientPEPSuccess: (state, action) => {
      state.consultClientPEP = {
        data: action.payload
      };
    },

    setConsultClientPEPFailure: (state, action) => {
      state.consultClientPEP = {
        error: action.payload,
      }
    },


    // Actualiza cliente pep positiva pregunta 1

    setActualizaClientePepPositivaPregunta1Loading: (state) => {
      state.clientePepPositivaPregunta1 = {
        isLoading: true,
      };
    },

    setActualizaClientePepPositivaPregunta1Success: (state, action) => {
      state.clientePepPositivaPregunta1 = {
        success: true,
        data: action.payload
      };
    },

    setActualizaClientePepPositivaPregunta1Failure: (state, action) => {
      state.clientePepPositivaPregunta1 = {
        error: action.payload,
      }
    },



    // Actualiza cliente pep positiva pregunta 2

    setActualizaClientePepPositivaPregunta2Loading: (state) => {
      state.clientePepPositivaPregunta2 = {
        isLoading: true,
      };
    },

    setActualizaClientePepPositivaPregunta2Success: (state, action) => {
      state.clientePepPositivaPregunta2 = {
        success: true,
        data: action.payload
      };
    },

    setActualizaClientePepPositivaPregunta2Failure: (state, action) => {
      state.clientePepPositivaPregunta2 = {
        error: action.payload,
      }
    },


    // Actualiza cliente pep respuestas negativas

    setActualizaClientePepRespuestasNegativasLoading: (state) => {
      state.clientePepRespuestasNegativas = {
        isLoading: true,
      };
    },

    setActualizaClientePepRespuestasNegativasSuccess: (state, action) => {
      state.clientePepRespuestasNegativas = {
        success: true,
        data: action.payload
      };
    },

    setActualizaClientePepRespuestasNegativasFailure: (state, action) => {
      state.clientePepRespuestasNegativas = {
        error: action.payload,
      }
    },


    // Clear update pep client store
    
    clearActualizaClientePepRespuestas: (state) => {
      state.clientePepPositivaPregunta1 = {};
      state.clientePepPositivaPregunta2 = {};
      state.clientePepRespuestasNegativas = {};
    },

  },
})

export const {
  setConsultClientPEPLoading, setConsultClientPEPSuccess, setConsultClientPEPFailure,
  setActualizaClientePepPositivaPregunta1Loading, setActualizaClientePepPositivaPregunta1Success, setActualizaClientePepPositivaPregunta1Failure,
  setActualizaClientePepPositivaPregunta2Loading, setActualizaClientePepPositivaPregunta2Success, setActualizaClientePepPositivaPregunta2Failure,
  setActualizaClientePepRespuestasNegativasLoading, setActualizaClientePepRespuestasNegativasSuccess, setActualizaClientePepRespuestasNegativasFailure,
  clearActualizaClientePepRespuestas
} = pepSlice.actions

export default pepSlice.reducer;